var render = function render(){var _vm=this,_c=_vm._self._c;return _c('s-field',{attrs:{"id":_vm.id,"name":_vm.name,"inputId":_vm.inputId,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function({ sState }){return [_c('input',{attrs:{"type":"hidden","id":_vm.id,"name":_vm.name,"required":_vm.required,"state":sState},domProps:{"value":_vm.value}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }